import { TableItem } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IAccountMutationForm } from 'services/accounts/types';
import { useGetPredefindedSalesChannels } from 'services/enums';

export const serviceInitialValues = {
  serviceName: '',
  available: true,
};

const AccountServices = () => {
  const {
    values,
    status,
    setFieldValue,
    initialValues,
  }: IFormikContextType<IAccountMutationForm> =
    useFormikContext<IAccountMutationForm>();

  const { t } = useTranslation();

  const availableServices = useGetPredefindedSalesChannels();

  useEffect(() => {
    availableServices.data?.length &&
      !values.availableServices.length &&
      setFieldValue(
        'availableServices',
        availableServices.data?.map((service, index) => ({
          serviceName: service.name,
          available:
            initialValues.availableServices.find(
              a => a.serviceId === service.id
            )?.available ?? false,
          serviceId: service.id,
        })) ?? []
      );
  }, [availableServices.status, initialValues.availableServices]);

  return (
    <Table
      id={'AccountServices2'}
      size='compact'
      data={{
        nodes: values.availableServices.map((s, index) => ({
          ...s,
          id: index,
        })),
      }}
      columns={[
        {
          label: t('input.label.serviceName'),
          renderCell: ({ serviceName, id }) => (
            <TableItem justifyPosition='start'>
              <TableItem.Text text={serviceName} />
            </TableItem>
          ),
          resize: true,
        },
        {
          label: t('input.label.available'),
          renderCell: ({ available, id }) => (
            <TableItem justifyPosition='start'>
              <FormInput.Checkbox
                name={`availableServices[${id}].available`}
                label={available ? t('input.label.available') : 'Not available'}
              />
            </TableItem>
          ),
        },
      ]}
    />
  );
};

export default AccountServices;
